<template>
    <!--Groups Dialog -->
    <!--Emits a 'close' event - so to close, must include @close="activeeditdialog=false"-->
    <v-dialog
            v-model="dialog"
            scrollable
            persistent
            max-width="600"

    >
        <GroupActions :checks="checks" closebutton @close="$emit('close',false)"  />
    </v-dialog>
</template>

<script>
  // import NewGroup from "./NewGroup";
  // import EditGroup from "./EditGroup";
  // import GroupList from "./GroupList";
  // import BaseBtn from "../BaseBtn";
  import GroupActions from "@/views/groups/GroupActions";
  export default {
    //components: {GroupActions, BaseBtn, GroupList, EditGroup, NewGroup},
    components: {GroupActions},
    name: "Groups",
    props:['checks','dialog'],
    data() {
      return {
        selectedgroup:undefined,
        editgroup:false,
        loading:false,
        loading1:false,
        loading2:false,
        groups:'groups'
      }
    },
    mounted() {
        //this.showactive = (Object.keys(this.$store.state.groups)[0].archived)?false:true
    },
    watch: {

    },
    methods: {
      closedialog(){
        this.loading=false;
        this.$emit('close',false)
      },
      async editGroup(g){
        let f = await this.$store.dispatch('getGroup',g.sortkey);
        this.selectedgroup = f.Item;
        this.editgroup=true;
      },
      getAllArchived () {
        let em = this;
        em.loading1=true
        let args = {
          url:this.$store.state.url + 'api/groups/archivedv2/'+this.$store.state.org.partkey,
          method:"GET"
        }
        this.$store.dispatch('fetch',args).then(res=>{
          em.$store.commit('setArchivedGroups',res)
          em.groups='archivedgroups'
          em.loading1=false
        }).catch(e=>{
            return e
        })
      },
      getAllActive(){
        let em = this;
        this.loading2=true
        let args = {
          url:this.$store.state.url + 'api/groups/allv2/' + this.$store.state.org.partkey,
          method:"GET"
        }
        this.$store.dispatch('fetch',args)
            .then((res)=>{
              em.$store.commit('setGroups', res.Item.contactgroups)
              em.groups='groups'
              em.loading2=false
            }).catch(e=> {return e} );

      }
    }
  }
</script>

<style scoped>

</style>